jQuery(document).ready(function ($) {
  if (document.body.classList.contains("block-editor-page")) return;

  const onScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };

    document.addEventListener("longevity:scroll-ready", runOnce, {
      once: true,
    });
    setTimeout(runOnce, 0);
  };

  if (typeof wp !== "undefined" && wp.domReady) {
    wp.domReady(() => onScrollReady(initHomeHero));
  } else {
    onScrollReady(initHomeHero);
  }

  function initHomeHero() {
    const blocks = document.querySelectorAll(".js-home-hero");
    if (!blocks.length) return;

    if (typeof window.gsap === "undefined") return;
    const gsap = window.gsap;

    const ScrollTrigger =
      window.ScrollTrigger ||
      ((gsync) =>
        gsync?.core?.globals ? gsync.core.globals().ScrollTrigger : null)(
        gsap,
      ) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (_) {}
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    blocks.forEach((el) => {
      if (el.dataset.heroInit === "1") return;
      el.dataset.heroInit = "1";

      const items = el.querySelectorAll(".js-hero-item");
      if (!items.length) return;

      if (reduceMotion) {
        gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
        return;
      }

      gsap.set(items, { autoAlpha: 0, y: 18 });

      if (!ScrollTrigger) {
        gsap.to(items, {
          autoAlpha: 1,
          y: 0,
          duration: 0.9,
          stagger: 0.12,
          ease: "power3.out",
          clearProps: "transform",
        });
        return;
      }

      gsap
        .timeline({
          defaults: { ease: "power3.out", duration: 0.9 },
          scrollTrigger: { trigger: el, start: "top 75%", once: true },
        })
        .to(items, {
          autoAlpha: 1,
          y: 0,
          stagger: 0.12,
          clearProps: "transform",
        });
    });
  }
});
